/**
 * Account Checking Manage : 对账管理
 */
import { generate } from '@/utils/request';
const config = {
  prefix: '/sfin/v1/{organizationId}',
  items: [
    // 对账列表
    { key: 'getAccountCheckingList', url: '/account/checking/list', method: 'POST' },
    // 确认对账
    { key: 'notarizeAccountChecking', url: '/account/checking/notarize', method: 'POST' },

    // 已对账列表
    { key: 'getAccountCheckingFinish', url: '/account/checking/finish', method: 'POST' },
    // 已对账详情
    { key: 'detailAccountCheckingFinish', url: '/account/checking/detail/{id}', method: 'GET' },

    // 待部门经理审核的总数
    { key: 'getTotalDepartmentAudit', url: '/work/order/TotalDepartmentAudit', method: 'POST' },
    // 超时的工单
    { key: 'getOvertimeWorkOrder', url: '/work/order/overtimeWorkOrder', method: 'POST' },
  ],
};

export default {
  ...generate(config),
};
